<template>
  <div>
    <IndexPage v-if="!logged" />
    <div class="row page-header" v-if="logged">
      <div class="col">
        <h1>Biriweb</h1>

        <Dashboard />
      </div>
    </div>
  </div>
</template>

<script>
import Dashboard from './components/Dashboard'
import IndexPage from './components/IndexPage'

export default {
  name: 'App',
  components: { Dashboard, IndexPage },
  data () {
    return {
      refresh_token_interval: null
    }
  },
  created () {
    this.refreshToken({now: true})
    this.refresh_token_interval = setInterval(this.refreshToken({now: false}), 300000) // refresh each 5 minutes
  },
  beforeDestroy () {
    clearInterval(this.refresh_token_interval)
  },
  computed: {
    logged () {
      return this.$cookies.isKey('api_token')
    }
  },
  methods: {
    refreshToken ({now=false}) {
      let self = this
      let api_token = this.$cookies.get('api_token')

      let successCallback = (response) => {
        if (response.body.data && response.body.data == 'ok') {

          let expire_at = new Date((new Date).getTime() + 60*60000);

          self.$cookies.set('api_token', self.$cookies.get('api_token'), expire_at)
          self.$cookies.set('user_name', self.$cookies.get('user_name'), expire_at)
          self.$cookies.set('user_email', self.$cookies.get('user_email'), expire_at)
          self.$cookies.set('business_id', self.$cookies.get('business_id'), expire_at)
        }
      }

      let errorCallback = (response) => {
        debugger
      }

      let doRequest = () => {
        if (api_token) {
          self.$http.get(`${this.$root.base_url}/refresh_token`, { headers: { Token: api_token } }).then(successCallback, errorCallback)
        }
      }

      if (now) {
        doRequest()
        return true
      } else {
        return doRequest
      }
    }
  },
  metaInfo: {
    style: [
      { cssText: 'body { background-color: #323273; }', type: 'text/css' }
    ]
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue